var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep5Walkthrough(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 200,
    viewBox: "0 0 142 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_6902)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3438 9.86326C77.8605 7.63496 75.9808 5.70058 73.8004 4.15581C63.7662 -3.00072 49.8222 -0.669893 42.6657 9.36428C40.2255 12.7888 38.7969 16.8352 38.5577 21.0389C38.4278 23.65 40.4374 25.8646 43.0417 25.9945C43.4859 26.015 43.9302 25.974 44.3677 25.8715C46.514 25.352 48.0246 23.4381 48.0314 21.2371C48.0997 16.7259 50.622 12.611 54.6069 10.4989C60.2734 7.5461 67.2522 9.35061 70.7792 14.6753L83.8824 37.054L92.3308 32.0984L79.3369 9.86326H79.3438Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7792 14.6754C70.7792 14.6754 72.7888 18.0998 75.2153 22.2489L83.3834 16.7738L79.3438 9.86334C78.2638 8.24338 76.9651 6.76697 75.4955 5.48877C73.8277 8.27072 71.9002 10.8955 69.7334 13.3152C70.1162 13.7458 70.4648 14.1969 70.7792 14.6754Z",
    fill: "#C94B32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.6786 19.0839C88.25 16.6506 85.6116 15.5433 83.7866 16.6164L45.0306 39.371C43.2056 40.4442 42.8912 43.2808 44.3129 45.7142L64.0395 79.3095C65.4681 81.7429 68.1065 82.8502 69.9315 81.777L108.687 59.0224C110.512 57.9561 110.827 55.1127 109.405 52.6793L89.6786 19.0839Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0039 40.868C76.5275 38.4073 73.3286 37.6076 70.8679 39.084C68.4414 40.5399 67.628 43.6705 69.0361 46.1312L75.5501 57.2248C76.9787 59.7197 80.1571 60.5809 82.6451 59.1524C85.14 57.7238 86.0012 54.5454 84.5726 52.0574C84.5521 52.03 84.5385 51.9958 84.518 51.9685L78.0039 40.8749V40.868Z",
    fill: "#B51C48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3144 162.659C95.2333 162.659 115.434 142.458 115.434 117.539C115.434 92.6204 95.2333 72.4197 70.3144 72.4197C45.3956 72.4197 25.1948 92.6204 25.1948 117.539C25.1948 142.458 45.3956 162.659 70.3144 162.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6699 150.26C88.9636 150.26 103.794 135.43 103.794 117.136C103.794 98.8422 88.9636 84.0122 70.6699 84.0122C52.3761 84.0122 37.5461 98.8422 37.5461 117.136C37.5461 135.43 52.3761 150.26 70.6699 150.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3225 120.69C61.8864 118.715 54.9623 117.573 57.5119 108.995C60.0614 100.417 63.3287 96.8763 67.423 96.2406C74.6206 94.7232 79.6513 102.987 79.6308 111.511C79.6035 120.041 67.5529 121.237 66.3225 120.69Z",
    fill: "#CC2F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9152 111.975C77.2044 108.209 76.4457 104.58 77.7307 105.755C79.0157 106.931 79.4053 108.633 80.5263 109.945C81.6473 111.258 81.2509 112.679 80.7997 114.921C80.3486 117.163 77.9152 111.975 77.9152 111.975Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5092 115.27C68.7423 115.885 66.76 115.461 64.771 115.126L64.3677 116.288C62.3786 115.96 60.0888 114.176 56.1927 116.036C50.868 118.571 49.2002 131.757 57.8195 138.346C58.6192 139.433 57.0744 142.898 55.4613 146.555C60.0204 148.913 65.1879 150.253 70.6698 150.253C77.0608 150.253 83.028 148.435 88.0929 145.304C88.0929 141.442 87.5803 136.924 86.7258 134.792C86.555 134.368 94.5044 132.256 92.2556 127.512C88.5509 119.686 79.166 114.962 75.5092 115.263V115.27Z",
    fill: "#CC2F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3745 116.159C65.8782 112.55 65.4681 108.688 63.5884 107.785C60.2528 106.227 62.0436 102.604 63.9644 102.768C67.1769 103.096 63.9985 98.6467 68.4415 98.134C72.9254 97.6077 76.3294 101.333 75.5365 105.516C74.7367 109.699 72.9186 108.64 73.5679 111.449C73.7661 112.372 74.1626 114.224 74.9828 115.113C75.844 116.138 73.9097 117.772 70.8475 117.806C68.1407 117.833 64.3061 116.309 64.3403 116.234L64.3813 116.159H64.3745Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7231 119.33C79.0362 113.411 78.1271 102.174 81.1688 102.85C84.2105 103.527 85.0376 114.833 81.9959 124.573C80.5741 129.132 72.9665 121.757 74.73 119.33H74.7231Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9905 114.272C88.633 110.492 89.1798 106.822 89.9795 108.373C90.7793 109.925 90.5537 111.654 91.1484 113.274C91.743 114.894 90.8818 116.09 89.6788 118.031C88.4758 119.98 87.9973 114.265 87.9973 114.265L87.9905 114.272Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2036 120.061C86.6096 114.374 91.989 106.275 94.5454 107.156C97.1018 108.038 90.1913 119.241 89.9589 125.29C89.7948 129.433 83.1988 122.454 84.2104 120.055L84.2036 120.061Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6254 172.023H23.5065C18.6593 172.023 14.73 175.951 14.73 180.796C14.73 185.641 18.6593 189.569 23.5065 189.569H55.6254C60.4725 189.569 64.4019 185.641 64.4019 180.796C64.4019 175.951 60.4725 172.023 55.6254 172.023Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8894 175.243H23.8825C20.8172 175.243 18.3323 177.728 18.3323 180.793V180.8C18.3323 183.865 20.8172 186.35 23.8825 186.35H23.8894C26.9547 186.35 29.4396 183.865 29.4396 180.8V180.793C29.4396 177.728 26.9547 175.243 23.8894 175.243Z",
    fill: "#B51C48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.225 182.447H78.0655C73.2184 182.447 69.2891 186.375 69.2891 191.22C69.2891 196.065 73.2184 199.993 78.0655 199.993H117.225C122.072 199.993 126.001 196.065 126.001 191.22C126.001 186.375 122.072 182.447 117.225 182.447Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4484 185.673H78.4416C75.3763 185.673 72.8914 188.158 72.8914 191.224V191.23C72.8914 194.296 75.3763 196.781 78.4416 196.781H78.4484C81.5137 196.781 83.9987 194.296 83.9987 191.23V191.224C83.9987 188.158 81.5137 185.673 78.4484 185.673Z",
    fill: "#CC2F22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6945 156.227C29.0191 156.227 37.3889 147.857 37.3889 137.532C37.3889 127.208 29.0191 118.838 18.6945 118.838C8.3698 118.838 0 127.208 0 137.532C0 147.857 8.3698 156.227 18.6945 156.227Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0136 141.258C19.9521 143.322 20.2187 148.79 22.1804 151.415C24.1421 154.046 9.26172 147.211 9.26172 147.211C9.26172 147.211 11.2303 140.273 11.9753 134.874C12.7204 129.48 11.531 123.978 18.9541 123.882C26.3977 123.848 31.5379 124.47 30.3212 128.899C29.1045 133.329 28.0792 133.821 24.9282 136.74C21.8455 139.631 20.0751 139.187 20.0068 141.251L20.0136 141.258Z",
    fill: "#751C48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2694 134.709C12.2694 134.709 12.8709 144.21 20.4512 147.02C20.4512 147.02 20.6836 149.542 22.6248 151.688C24.6207 153.814 26.1313 154.915 26.1313 154.915C26.1313 154.915 10.3419 147.478 9.54214 147.191C8.67406 146.924 6.00146 148.975 6.00146 148.975L12.2762 134.709H12.2694Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0649 130.786C15.0649 130.786 10.4647 129.275 10.2802 131.804C10.0751 134.477 11.7839 135.154 12.3239 136.097C13.9097 138.858 15.6664 141.914 19.6035 142.734C23.5406 143.554 26.0833 140.923 27.0881 134.245C28.0724 127.505 18.9473 121.64 15.0649 130.793V130.786Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73947 145.584C5.87139 146.63 4.89395 147.765 3.93018 148.988C7.34781 153.39 12.693 156.227 18.7012 156.227C21.9343 156.227 24.976 155.406 27.6281 153.964C26.5139 152.871 25.2767 151.852 23.6704 150.8C19.4531 147.963 9.20017 142.7 6.74631 145.584H6.73947Z",
    fill: "#751C48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.151 158.291C133.476 158.291 141.845 149.921 141.845 139.597C141.845 129.272 133.476 120.902 123.151 120.902C112.826 120.902 104.457 129.272 104.457 139.597C104.457 149.921 112.826 158.291 123.151 158.291Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.031 152.051C113.903 152.734 112.625 153.055 111.346 154.094C114.566 156.719 118.667 158.291 123.144 158.291C129.706 158.291 135.475 154.908 138.811 149.788C129.392 146.726 122.194 147.813 115.024 152.051H115.031Z",
    fill: "#188C7C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.892 133.52C112.112 139.904 113.8 143.404 116.555 144.614C120.649 145.94 119.398 150.547 119.357 153.684C119.385 156.206 120.143 154.074 128.769 147.997C128.769 147.997 127.772 147.232 127.895 144.545C128.018 141.859 129.508 136.924 127.71 132.857C125.885 128.886 118.332 129.282 115.885 133.527L115.892 133.52Z",
    fill: "#1A395F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.448 136.829C125.448 136.829 130.294 137.874 126.774 141.08C123.158 144.258 128.038 146.678 128.038 146.678C128.038 146.678 134.306 142.146 131.449 136.295C134.757 130.383 127.225 131.729 125.154 128.284C122.481 123.835 116.049 125.236 114.443 128.606C112.59 132.597 115.4 134.539 115.427 134.436C117.32 130.67 119.036 131.675 121.128 132.051C127.375 132.96 125.454 136.829 125.454 136.829H125.448Z",
    fill: "#188C7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_6902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141.839,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5Walkthrough);
export default __webpack_public_path__ + "static/media/step_5_walkthrough.ad0212bcc13e99a19c8530cf3a6b35cd.svg";
export { ForwardRef as ReactComponent };